import './shredieck.css';
import { useEffect, useRef, useState } from 'react';
import { YIN } from "pitchfinder";
import ShredieckScroller from './shredieckScroller';
import shredieckNotes from './shredieckNotes';
import { getDatabase, onValue, ref, set } from 'firebase/database';


function musicNotation(f) {

  const A4 = 440.0;
  const C0 = A4 * Math.pow(2.0, -4.75);

  const names = [
    "C", "Cs", "D", "Ds", "E", "F",
    "Fs", "G", "Gs", "A", "As", "B"
  ];

  const r =
    12.0 * Math.log(f / C0) / Math.log(2.0);

  const h = Math.round(r);

  const octave = Math.floor(h / 12.0);

  const n = ((h % 12) + 12) % 12;

  return [names[n], octave];
}

function Shredieck({app,user}) {

  const highestScoreRef=useRef(0);
  const highScoreRef=useRef(0);
  const fail = (score)=>{
    if(highestScoreRef.current < score){
      console.log('set')
      set(ref(getDatabase(app),'users/highest/score'),score).then(ok => 1).catch(console.error);
    }
    if(highScoreRef.current < score)
    set(ref(getDatabase(app),'users/'+user.uid+'/score'),score).then(ok => 1).catch(console.error);
  }
  const notesCorrespondances = {
    Ab:'Gs',
    A:'A',
    As:'As',
    Bb:'As',
    B:'B',
    Bs:'C',
    Cb:'B',
    C:'C',
    Cs:'Cs',
    Db:'Cs',
    D:'D',
    Ds:'Ds',
    Eb:'Ds',
    E:'E',
    Es:'F',
    Fb:'E',
    F:'F',
    Fs:'Fs',
    Gb:'Fs',
    G:'G',
    Gs:'Gs',
  }
  const [speed, setSpeed]=useState(150);
  const [audioContext, setAudioContext] =
    useState(null);

  const [hasStart, setHasStart] =
    useState(false);

  const [noteShred, setNoteShred] =
    useState(['C', 4]);

  const currentIndex = useRef(0);
  const hasStarted = useRef(false);


  const oldNote = useRef('');
  const time = useRef(-3000);
  const timeInterval = useRef();

  const animationRef = useRef(null);

  const start = async () => {

    setHasStart(true);
    hasStarted.current=true;

    if (
      audioContext &&
      audioContext.state === 'suspended'
    ) {
      await audioContext.resume();
    }
  };
  useEffect(()=>{
    if(!hasStart){
      clearInterval(timeInterval.current);
      time.current = -3000;
    }
    else{
      clearInterval(timeInterval.current);
      timeInterval.current = setInterval(()=>{
        time.current += 100;
        const expectedTime =

  currentIndex.current * speed;

if (

  time.current >

  expectedTime + 1000

) {

  console.log('TOO LATE');
  fail(currentIndex.current);
  setHasStart(false);
  hasStarted.current = false;

      currentIndex.current = 0;

      oldNote.current = '';
  return;
}
      }, 100);
    }
  },[hasStart])
  const updatePitch = (
    analyserNode,
    detector,
    input
  ) => {
    analyserNode.getFloatTimeDomainData(input);

    const pitch = detector(input);

    if (pitch) {

  const note = musicNotation(pitch);
      
  if (
    hasStarted.current &&
    note[0] &&
    oldNote.current !== note[0] &&
    note[1] < 6 &&
    note[1] > 3
  ) {
    if (
      currentIndex.current >=
      shredieckNotes.length
    ) {
      console.log('FINISHED');
      return;
    }

    // search up to 5 notes ahead
    let foundIndex = -1;

    for (
      let i = currentIndex.current;
      i <= currentIndex.current + 5 &&
      i < shredieckNotes.length;
      i++
    ) {

      const expectedNote =
        (i==2)?shredieckNotes[i][1]:notesCorrespondances[shredieckNotes[i].substring(1)];
      if (note[0] === expectedNote) {

        foundIndex = i;
        break;
      }
    }

    // found matching note
    if (foundIndex !== -1) {
      
      console.log(
        'correct',
        'jumped to',
        foundIndex
      );
      document.getElementById('score').innerHTML = foundIndex + 1;
      // move cursor AFTER matched note
      currentIndex.current =
        foundIndex + 1;

    } else {

      // full fail only if note
      // isn't in next 5 notes

      fail(currentIndex.current);
      hasStarted.current = false;

      currentIndex.current = 0;

      oldNote.current = '';

      setHasStart(false);
    }

    oldNote.current = note[0];

    setNoteShred(note);
  }
}

    // NO DELAY
    animationRef.current =
      requestAnimationFrame(() => {

        updatePitch(
          analyserNode,
          detector,
          input
        );

      });
  };

  useEffect(() => {

    if (!audioContext) return;

    const analyserNode =
      audioContext.createAnalyser();

    analyserNode.fftSize = 4096;

    navigator.mediaDevices
      .getUserMedia({
        audio: true
      })
      .then((stream) => {

        const source =
          audioContext.createMediaStreamSource(stream);
        source.connect(analyserNode);

        const detector = YIN({
          sampleRate: audioContext.sampleRate,
          threshold: 0.05,
          probabilityThreshold:0.85
        });

        const input =
          new Float32Array(
            analyserNode.fftSize
          );

        updatePitch(
          analyserNode,
          detector,
          input
        );
      });

    return () => {

      if (animationRef.current) {

        cancelAnimationFrame(
          animationRef.current
        );
      }
    };

  }, [audioContext]);
  const [highScore,setHighScore]=useState(0);
  const [highestScore,setHighestScore]=useState(0);
  useEffect(() => {
const highestRef = ref(getDatabase(app), 'users/highest');
onValue(highestRef, (snapshot) => {
  
  if(!snapshot.exists()){
    setHighestScore(0);
    highestScoreRef.current = 0;
    return;
  }
  const data = snapshot.val();
    setHighestScore(data.score || 0);
    highestScoreRef.current = data.score || 0;
});
    const starCountRef = ref(getDatabase(app), 'users/' + user.uid);
onValue(starCountRef, (snapshot) => {
  
  if(!snapshot.exists()){
    setHighScore(0)
    highScoreRef.current = 0;
    return;
  }
  const data = snapshot.val();
    setHighScore(data.score||0);
    highScoreRef.current = data.score||0;
});
    const ctx =
      new window.AudioContext({
        latencyHint: 'interactive'
      });

    setAudioContext(ctx);

    return () => {
      ctx.close();
    };

  }, []);

  return (
    <>
      <div className='shredieck'>

        {hasStart ? (

          <div className='game'>

            <div
              className={
                noteShred[1] === 5
                  ? 'shredIcon up shred ' + noteShred[0].charAt(0)
                  : noteShred[1] === 6
                  ? 'shredIcon upup shred ' + noteShred[0].charAt(0)
                  : 'shredIcon shred ' + noteShred[0].charAt(0)
              }
            >
              <img src='/shredieck.png'/>
              <div className='liness'>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>

            </div>

            <div className='lines'>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div className='shredNotes'>
             
             <ShredieckScroller speed={speed}/>

          </div>
          </div>

        ) : (<div className='shredieckScreen'>
          <img className='shredieckBg' src='/bg.png'/>
          <img className='shredieckBorder' width={'100%'} height={'100%'} src='/border.png'/>
          
          
          <button onClick={start} className='shredieckButton'>
            Start
          </button>
          <div className='shredieckButtons'>
            <div>
              <img src="/high.png"/>
              <p>{highScore}</p>
            </div>
            <div>
              <img src="/highest.png"/>
              <p>{highestScore}</p>
            </div>
          </div>
</div>
        )}

      </div>
    </>
  );
}

export default Shredieck;